export default {"src":"/_next/static/media/aboutSays.22a6a0be.svg","height":31,"width":44};